import { useTypedSelector } from './useTypedSelector'

export const useTranslation = () => {
    const translation = useTypedSelector(
        (state) => state.translation.translation
    )

    return translation
}
